export default "__VITE_ASSET__B4imtl$5__"